import { useState } from "react";

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import routes from "routes";
import ActivateBrowserNotifAlert from "components/Alerts/ActivateBrowserNotifAlert";
import { ArrowLongComponent } from "assets/icons";
import ReconnectingAlert from "components/Alerts/ReconnectingAlert";
import ExpirePackageBanner from "components/Alerts/ExpirePackageBanner";
import styles from "./styles.module.scss";
import clsx from "clsx";
import { PACKAGE_UPGRADE_LINK } from "utils/constants";
import useTranslation from "hooks/useTranslation";

const getContainer = ({ userData }) => userData.container.data;

function Alerts() {
  const [isActiveBrowserNotification, setIsActiveBrowserNotification] =
    useState(false);
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();

  const location = useLocation();

  const pathname = location.pathname;

  const container = useSelector(getContainer);
  const isPackageExpired = container?.package?.type === "expire";

  const showExpireAlert = isPackageExpired;
  // notif alert should get displayed only in related pages and only if user's package is not expired
  const showNotifAlert =
    !isPackageExpired &&
    [routes.chats, routes.convsList, routes.home].includes(pathname);

  return (
    <div id="alerts" className={styles.notifications_wrapper}>
      {/* <div className={styles.price_increase_notification}>
        <span className={styles.text_1}>
          اکانتت رو با همون قیمت پارسال، قبل از افزایش قیمت، تمدید کن
        </span>
        <span className={styles.text_2}>فقط تا ۲۰ فروردین</span>
        <a
          className={clsx([styles.action_btn, styles.action_btn__primary])}
          rel="noreferrer"
          target="_blank"
          href={PACKAGE_UPGRADE_LINK}
        >
          <ArrowLongComponent className={styles.action_btn__icon} />
          {t("RENEW")}
        </a>
      </div> */}
      {showNotifAlert && (
        <ActivateBrowserNotifAlert
          isActiveBrowserNotification={isActiveBrowserNotification}
          setIsActiveBrowserNotification={setIsActiveBrowserNotification}
        />
      )}
      <ReconnectingAlert />
      {showExpireAlert && <ExpirePackageBanner />}
    </div>
  );
}

export default Alerts;
